export const BASE_URL = 'http://www.adultswim.com';
export const DATETIME_DISPLAY_FORMAT = 'MMMM Do YYYY';
export const HOME_BASE_URL = '/';
export const IMAGE_UPLOAD_URL = '/comics/media/v1/upload';
export const TWITTER_IMAGE_SHARE = 'https://twitter.com/intent/tweet?hashtags=adultswim,webcomics&text=' + encodeURI('Check out this thing I drew on http://adultswim.com.') + ' ';
export const FACEBOOK_IMAGE_SHARE = 'https://www.facebook.com/dialog/feed?app_id=222143901136511&link=';



// WEBPACK FOOTER //
// ./src/client/constants/config.js